import { useDispatch } from "react-redux";

import { Select } from "@/storybook-components";
import type { ProjectsFilter } from "@/types";
import { setCurrentPage, updateFinder } from "@/redux/features/projects/slice";
import { FINDER_WIDE } from "../breakpoints";

const SelectFilter = ({
  options,
  label,
  type,
  selectedValue,
  boxClass
}: ProjectsFilter): JSX.Element => {
  const dispatch = useDispatch();

  const handleChange = (e: { value: string }): void => {
    getDispatched(e?.value);
    dispatch(setCurrentPage(1));
  };

  const getDispatched = (value: string): void => {
    switch (type) {
      case "tag":
        dispatch(
          updateFinder({ platformAnalyticsTagList: value ? [value] : null })
        );
        break;
      case "state":
        dispatch(updateFinder({ state: value || "" }));
        break;
      default:
        dispatch(updateFinder({ publishedAt: value || "" }));
    }
  };

  return (
    <Select
      isClearable
      isFullWidth
      value={selectedValue}
      onChange={handleChange}
      options={options}
      menuPlacement="auto"
      className="ehq-dropdownContainer"
      aria-label={label}
      placeholder={label}
      instanceId={label}
      innerProps={{
        p: 2,
        minW: 0,
        className: boxClass,
        css: { width: "100%", [FINDER_WIDE]: { width: "33.33%" } }
      }}
    />
  );
};

export default SelectFilter;
